angular.module('impactx.controlstructure').controller('INOCtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    INOCtrl
]);

function INOCtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/ino/view";
    $scope.endPointSave = "/control/ino/save";
    $scope.endPointDelete = "/control/ino/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.ino.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.ino.readOnly && !$scope.data.ino.deprecated;
    }
}